"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcceptInvitationScene = void 0;
const axios_1 = __importDefault(require("axios"));
const formik_1 = require("formik");
const react_1 = __importStar(require("react"));
const react_helmet_1 = __importDefault(require("react-helmet"));
const react_i18next_1 = require("react-i18next");
const react_router_1 = require("react-router");
const apis_1 = require("../../apis");
const AuthLayout_1 = require("../../components/AuthLayout/AuthLayout");
const Loading_1 = require("../../components/Loading/Loading");
const config_1 = require("../../config");
const parse_params_1 = require("../../parse-params");
const requests_1 = require("../../requests");
const routes_1 = require("../../routes");
const InvitationForm_1 = require("../../scene-forms/InvitationForm");
const CONTEXT = 'AcceptInvitationScene';
exports.AcceptInvitationScene = () => {
    const [redirect, setRedirect] = react_1.useState('');
    const [message, setMessage] = react_1.useState('');
    const [token, setToken] = react_1.useState('');
    const [userId, setUserId] = react_1.useState('');
    const [isLoading, setIsLoading] = react_1.useState(true);
    const { t } = react_i18next_1.useTranslation('AcceptInvitationScene');
    const location = react_router_1.useLocation();
    const redirectToAuthErrorPage = (msg) => {
        setRedirect(config_1.getAuthErrorUrl(msg));
    };
    react_1.useEffect(() => {
        parse_params_1.parseAndGetQuery(location, true, ['uid', 'invitation_token'])
            // eslint-disable-next-line camelcase
            .then(({ uid, invitation_token }) => {
            setUserId(uid);
            setToken(invitation_token);
            return requests_1.validateInvitationTokenRequest(uid, invitation_token);
        })
            .then(() => setIsLoading(false))
            .catch((e) => redirectToAuthErrorPage(config_1.getErrorMessage(e)));
    }, [location]);
    const onSubmit = (body) => {
        let url = apis_1.getApis().ACCEPT_INVITATION.replace(':invitationToken', token);
        url = url.replace(':userId', userId);
        axios_1.default.post(url, body)
            .then(() => setRedirect(routes_1.routes.ACCEPT_INVITATION_SUCCESS))
            .catch((e) => setMessage(config_1.getErrorMessage(e)));
    };
    const initValues = { password: '' };
    if (redirect)
        return react_1.default.createElement(react_router_1.Redirect, { to: redirect });
    if (isLoading)
        return react_1.default.createElement(Loading_1.Loading, { centeredVertical: true });
    return (react_1.default.createElement(AuthLayout_1.AuthLayout, { context: CONTEXT, links: [] },
        react_1.default.createElement(react_helmet_1.default, null,
            react_1.default.createElement("title", null, `${t('title')}`)),
        react_1.default.createElement(formik_1.Formik, { initialValues: initValues, onSubmit: onSubmit }, () => react_1.default.createElement(InvitationForm_1.InvitationForm, { context: CONTEXT, message: message }))));
};
//# sourceMappingURL=AcceptInvitationScene.js.map